<template>
    <!-- 对话框 -->
    <el-dialog title="服务人员资金流水" :visible.sync="show" :before-close="closeDialog" width="80%">
        <div style="width: 95%; margin: 0 auto">
            <div>
                <div class="handle-box-search">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span>操作类型: </span>
                                <el-select
                                    style="width: 340px"
                                    v-model="search_data_children.operation"
                                    placeholder="请选择"
                                    clearable
                                    @keyup.enter.native="recordInit"
                                >
                                    <el-option label="后台调整-余额" value="adminEditBalance"> </el-option>
                                    <el-option label="后台调整-服务费" value="adminEditInsurance"> </el-option>
                                    <el-option label="后台调整-保证金" value="adminEditBond"> </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <span>手机号：</span>
                                <el-input
                                    v-model="search_phone"
                                    placeholder="请输入手机号码"
                                    maxlength="11"
                                    style="width: 340px"
                                    @keyup.enter.native="searchConsumerLists"
                                ></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="head-search">
                            <el-col :span="24">
                                <span> 操作时间: </span>
                                <el-date-picker
                                    v-model="search_time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="timeChange"
                                    style="margin-bottom: 20px; margin-right: 20px; width: 340px"
                                >
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button @click="waterSearch">搜索</el-button>
                    <el-button :icon="!progress_show ? 'el-icon-setting' : 'el-icon-loading'" @click="toExport" :disabled="progress_show">{{
                        progress_show ? '正在导出...' : '导出'
                    }}</el-button>
                    <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                        <el-progress :percentage="progress_data"></el-progress>
                        <i class="el-icon-loading"></i>
                        正在导出...
                    </div>
                </div>
            </div>

            <div class="driver_water">
                <div><span>查询时间段内增加余额：</span>{{ addBalanceSum }}</div>
                <div><span>查询时间段内增加服务费：</span>{{ addInsuranceSum }}</div>
                <div><span>查询时间段内增加保证金：</span>{{ addBondSum }}</div>
                <div><span>查询时间段内减少余额：</span>{{ subBalanceSum }}</div>
                <div><span>查询时间段内减少服务费：</span>{{ subInsuranceSum }}</div>
                <div><span>查询时间段内减少保证金：</span>{{ subBondSum }}</div>
            </div>

            <!-- 表格 -->
            <el-table :data="tableData" max-height="500" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <div>
                                <el-form-item label="对应表:">
                                    <span>{{ props.row.table_name }}</span>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="相关编号:">
                                    <span>{{ props.row.record_code }}</span>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item label="备注:">
                                    <span>{{ props.row.remark }}</span>
                                </el-form-item>
                            </div>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="real_name" label="司机姓名"> </el-table-column>
                <el-table-column prop="phone" label="司机电话"> </el-table-column>

                <el-table-column prop="operation_name" label="账户操作"> </el-table-column>

                <el-table-column prop="amount" label="金额"> </el-table-column>

                <!-- <el-table-column prop="order_mode.name" label="订单模式"> </el-table-column> -->

                <el-table-column prop="description" label="描述"> </el-table-column>

                <el-table-column prop="surplus" label="结算后余额"> </el-table-column>
                <!-- <el-table-column prop="surplus" label="结算后服务费"> </el-table-column> -->

                <el-table-column prop="date_time" label="创建时间"> </el-table-column>

                <el-table-column prop="mode_name" label="账本模式"> </el-table-column>
                <el-table-column prop="operator" label="操作账户"> </el-table-column>
                <el-table-column prop="operator_name" label="操作人"> </el-table-column>
            </el-table>

            <!-- element ui 原生分页组件 -->
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data_children.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="search_data_children.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="result_data.count"
                >
                </el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },

    components: {},
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            loading: false,
            progress_show: false,
            progress_data: 0, // 导出进度条
            excelData: [],

            excelHead: [],
            search_phone: '',
            result_data: [],
            addBalanceSum: '',
            addBondSum: '',
            subBondSum: '',
            addInsuranceSum: '',
            subBalanceSum: '',
            subInsuranceSum: '',
            show: false,

            search_time: '',

            tableData: [],

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                operation: '',
                phone: '',
                fixed_time: ''
            },
            search_data_export: {
                page: 1,
                limit: 50,
                operation: '',
                phone: '',
                fixed_time: ''
            },

            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },

            // 表单提交数据
            search_data_getBalance: {
                // page: 1,
                // limit: 10,
                fixed_array: '',
                phone: ''
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        toExport() {
            if (_this.search_data_children.fixed_time == '' || _this.search_data_getBalance.fixed_array == '') {
                this.$message.error('查询时间为必填项！');
                return;
            }

            _this.search_data_children.page = 1;
            _this.search_data_children.limit = 50;

            _this.getExcelData();
        },

        getExcelData() {
            // console.log('_this.getExcelData()方法刚刚进入');
            _this
                .$post('/driver/driverRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    _this.progress_show = true;
                    // console.log(_this.progress_show, '_this.progress_show回调');

                    if (this.$route.path == '/driver') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            console.log(res.data[i].operator,'res.data[i].operator,');
                            console.log(res.data[i].operator_name,'res.data[i].operator_name,');
                            _this.excelData.push({
                                real_name: res.data[i].real_name,
                                phone: res.data[i].phone,
                                operation: res.data[i].operation_name,
                                amount: res.data[i].amount,
                                description: res.data[i].description,
                                surplus: res.data[i].surplus,
                                time: res.data[i].date_time,
                                mode: res.data[i].mode_name,
                                operator: res.data[i].operator,
                                operator_name: res.data[i].operator_name
                            });
                        }
                       

                        if (_this.search_data_children.page * _this.search_data_children.limit < res.count) {
                            _this.search_data_children.page = _this.search_data_children.page + 1;
                            _this.progress_data = Math.floor(
                                ((_this.search_data_children.page * _this.search_data_children.limit) / res.count) * 100
                            );
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data_children.page = 1;
                            _this.search_data_children.limit = 50;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '司机姓名',
                '司机电话',
                '账户操作',
                '金额',
                '描述',
                '结算后余额',
                '创建时间',
                '账本模式',
                '操作账号',
                '操作人姓名'
            ];
            const filterVal = [
                'real_name',
                'phone',
                'operation',
                'amount',
                'description',
                'surplus',
                'time',
                'mode',
                'operator',
                'operator_name'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '时间段内司机资金流水');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        waterSearch() {
            _this.search_data_children.phone = _this.search_phone;
            _this.search_data_getBalance.phone = _this.search_phone;
            if (_this.search_data_children.fixed_time == '' || _this.search_data_getBalance.fixed_array == '') {
                this.$message.error('查询时间为必填项！');
                return;
            }
            _this.recordInit();
            _this.getBalanceSumByTime();
        },

        timeChange(val) {
            if (val != null) {
                _this.search_data_children.fixed_time = ['between'].concat(val);
                _this.search_data_export.fixed_time = ['between'].concat(val);
                _this.search_data_getBalance.fixed_array = ['between'].concat(val);
            } else {
                _this.search_data_children.fixed_time = '';
                _this.search_data_export.fixed_time = '';
                _this.search_data_getBalance.fixed_array = '';
            }
        },

        // 获取账单信息
        recordInit() {
            _this
                .$post('/driver/driverRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data_children.limit = val;

            //初始化列表
            _this.waterSearch();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.waterSearch();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.waterSearch();
        },

        // 获取钱包信息
        getBalanceSumByTime() {
            _this
                .$post('/driver/getBalanceSumByTime', _this.search_data_getBalance)
                .then((res) => {
                    // 将获取到的数据赋值
                    _this.addBalanceSum = res.data.addBalanceSum;
                    _this.addBondSum = res.data.addBondSum;
                    _this.subBondSum = res.data.subBondSum;
                    _this.addInsuranceSum = res.data.addInsuranceSum;
                    _this.subBalanceSum = res.data.subBalanceSum;
                    _this.subInsuranceSum = res.data.subInsuranceSum;
                })
                .catch((err) => {});
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.search_time = '';
            _this.addBalanceSum = '';
            _this.addBondSum = '';
            _this.subBondSum = '';
            _this.addInsuranceSum = '';
            _this.subBalanceSum = '';
            _this.subInsuranceSum = '';
            _this.search_data_children = {
                page: 1,
                limit: 10,
                operation: '',
                fixed_time: ''
            };
            _this.search_data_export = {
                page: 1,
                limit: 10,
                operation: '',
                fixed_time: ''
            };
            _this.search_data_getBalance = {
                fixed_array: ''
            };

            _this.submit_data = {
                driver_code: '',
                mode: '',
                operation: '',
                amount: '',
                remark: ''
            };
        }
    }
};
</script>

<style scoped>
.search_style {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.driver_water {
    color: #606266;
    margin-bottom: 20px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.capital-title {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}
.money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}
.money {
    margin-left: 5px;
}
.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
    border: 0 !important;
}
.el-date-range-picker__time-header {
    display: block;
}
</style>




